<script>
/**
 * Footer component
 */
export default {
  name: 'Footer'
}
</script>

<template>
  <div>
    <!--START FOOTER-->
    <footer class="footer"
    :style="{'background-image': 'url(' + require('@/assets/images/home-image.png') + ')', 'background-size': 'cover','background-position': 'center'}"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-3 margin-t-20">
            <h4>Inovative Solutions</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
               <p>Empowering Growth through Inovative Solutions</p>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Pages</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a href="#">Home</a>
                </li>
                <li>
                  <a href="#proccess">Process</a>
                </li>
                <li>
                  <a href="#contact-form">Get in touch</a>
                </li>
                <!-- <li>
                  <a href="#">Simple Marketing</a>
                </li> -->
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Get in Touch</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <!-- <li>
                  <a href>Office Adress: </a>
                </li> -->
                <li>
                  <a href>Phone Number: <br> +359 876 669 028</a>
                </li>
                <li>
                  <a href>Email Adress: support@inovativesolutions.co</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt"
    
    :style="{'background-image': 'url(' + require('@/assets/images/home-image.png') + ')', 'background-size': 'cover','background-position': 'center'}"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p
                class="copy-rights text-muted mb-3 mb-sm-0"
              >{{ new Date().getFullYear()}} © Inovative Solutions</p>
            </div>
            <div class="float-right pull-none">
              <ul class="list-inline social m-0">
                <li class="list-inline-item">
                  <a href="https://www.facebook.com" class="social-icon">
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li> -->
                <li class="list-inline-item">
                  <a href="https://www.linkedin.com" class="social-icon">
                    <i class="mdi mdi-linkedin"></i>
                  </a>
                </li>
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-google-plus"></i>
                  </a>
                </li> -->
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-dribbble"></i>
                  </a>
                </li> -->
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>